export interface IError {
  message: string | null;
  show?: boolean;
  showSuccess?: boolean;
}

export interface ToastMessage {
  status: 'success' | 'error';
  text: string;
}

export enum LogoutReason {
  sessionExpired = 'session_expired',
  sessionSuperseded = 'session_superseded',
}

export const logoutReasonToMessageText = {
  [LogoutReason.sessionExpired]:
    'For your security, you have been logged out. Please log back in.',
  [LogoutReason.sessionSuperseded]:
    'Your web account is already in use on another device.',
};

export interface IMessagesState {
  toastMessage: ToastMessage;
  message: string | null;
  show?: boolean;
  showSuccess?: boolean;
  logoutReason?: LogoutReason;
  versionFetchComplete: boolean;
}
